"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddVoucherForm = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _styled = require("../styled");
var _styles = require("./styles");
var _useVoucherForm = require("./useVoucherForm");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- x */

const AddVoucherForm = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    isSimplifiedCheckout
  } = (0, _contexts.useCheckoutBasket)();
  const {
    shoppingBag
  } = (0, _contexts.useBasketContext)();
  const {
    error,
    handleAddToBasket,
    handleClick,
    handleClose,
    handleMouseEnter,
    handleMouseLeave,
    isOpen,
    isTooltipOpen,
    resetError
  } = (0, _useVoucherForm.useVoucherForm)();
  const testId = getTestId('promo-code');
  const {
    handleSubmit,
    register
  } = (0, _reactHookForm.useFormContext)();
  const {
    errors
  } = (0, _reactHookForm.useFormState)();
  const {
    onChange,
    ...voucherCodeRegister
  } = register('voucherCode');
  const helperText = errors.voucherCode?.message?.toString() ?? error;
  if (isSimplifiedCheckout ?? !shoppingBag) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.BasketCardForm, {
    "data-testid": `${testId}-form`,
    onSubmit: handleSubmit(handleAddToBasket),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.VoucherLabel, {
      variant: "body1",
      overflow: "hidden",
      id: "voucher-label",
      children: formatMessage('promotionCode')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CellInput, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.InputWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
          fullWidth: true,
          id: "voucherCode",
          ...voucherCodeRegister,
          error: Boolean(errors.voucherCode),
          helperText: helperText,
          type: "text",
          variant: "standard",
          InputProps: {
            inputProps: {
              // eslint-disable-next-line @typescript-eslint/naming-convention -- html attribute
              'data-testid': `${testId}-input`,
              'aria-labelledby': 'voucher-label'
            }
          },
          onChange: e => {
            void onChange(e);
            resetError();
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackNotification, {
          "data-testid": `${testId}-success-notification`,
          open: isOpen,
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Check, {}),
          onClose: handleClose,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            children: formatMessage('added')
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ErrorWrapper, {
          children: error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
            open: isTooltipOpen,
            title: error,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ExclamationMark, {
              "data-testid": `${testId}-error`,
              onMouseEnter: handleMouseEnter,
              onMouseLeave: handleMouseLeave,
              onClick: handleClick
            })
          }) : null
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CellButton, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          "data-testid": `${testId}-button`,
          disabled: Boolean(errors.voucherCode),
          size: "small",
          type: "submit",
          variant: "outlined",
          children: formatMessage('activate')
        })
      })]
    })]
  });
};
exports.AddVoucherForm = AddVoucherForm;